import i18next from 'i18next'
import React from 'react'
import { none } from 'widgets-for-react'
import { getCookie } from '../../utils/cookies'
import { ComponentDidMount } from '../../utils/lifecycleMethods'
import { LinkBlockLayout } from '../cmsPage/blocks/linkBlockLayout'
import { GenericPageHeader } from '../cmsPage/pages/generic'

export const NotFoundLayout = () => (
  <ComponentDidMount
    onMount={() => {
      document.title = i18next.t('notFound:pageNotFoundDocumentTitle')
    }}
  >
    <GenericPageHeader
      notFoundOrEmptyPage={true}
      readSpeakerCookieAccepted={getCookie('readspeaker-cookies') === 'yes'}
      title={i18next.t('notFound:pageNotFoundTitle')}
      path={'/'}
      image={'/images/404-1040w.jpg'}
      parent={none()}
    />
    <LinkBlockLayout
      title={i18next.t('notFound:pageNotFound')}
      intro={i18next.t('notFound:pageNotFoundIntro')}
      items={[
        { title: 'Home', url: '/' },
        {
          title: i18next.t('notFound:pageNotFoundKennis'),
          text: i18next.t('notFound:pageNotFoundKennisIntro'),
          url: '/kennis'
        },
        {
          title: i18next.t('notFound:pageNotFoundOpleidingen'),
          text: i18next.t('notFound:pageNotFoundOpleidingenIntro'),
          url: '/opleidingen'
        },
        {
          title: i18next.t('notFound:pageNotFoundContact'),
          text: i18next.t('notFound:pageNotFoundContactIntro'),
          url: '/contact'
        },
        {
          title: i18next.t('notFound:pageNotFoundSearch'),
          text: i18next.t('notFound:pageNotFoundSearchIntro'),
          url: '/zoeken'
        }
      ]}
      index={2}
      SVGIcon={{
        width: '18px',
        height: '18px'
      }}
    />
  </ComponentDidMount>
)
